import { notifications } from '@mantine/notifications';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { persistConfig, queryKeys } from '../../api/config';
import { authRoutes, routes } from '../../router/routes';

export const SessionManager = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleSessionExpired = () => {
      if (
        Object.values(authRoutes).some((route) =>
          location.pathname.includes(route)
        )
      ) {
        return;
      }

      const userData = queryClient.getQueryData([queryKeys.meKey]);
      if (!userData) {
        return;
      }

      localStorage.removeItem(persistConfig.key);

      queryClient.removeQueries();

      notifications.show({
        autoClose: 5000,
        color: 'yellow',
        message: 'Your session has expired. Please log in again.',
        title: 'Session Expired',
      });

      navigate(routes.login);
    };

    window.addEventListener('session-expired', handleSessionExpired);

    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, [navigate, queryClient, location.pathname]);

  return null;
};
